import { motion } from "framer-motion";

const theme = {
    primary: "#820f99",
    deep: "#301466",
    light: "#c084fc",
    accent: "#d946ef",
    yellow: "#EFCD46FF",
};

export default function RewardLoader() {
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="relative w-32 h-32 flex items-center justify-center">

                {/* Outer Ring */}
                <motion.div
                    className="absolute w-32 h-32 rounded-full border-4"
                    style={{
                        borderColor: theme.accent,
                        boxShadow: `0 0 20px ${theme.accent}`,
                    }}
                    animate={{ rotate: 360 }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "linear",
                    }}
                />

                {/* Inner Ring */}
                <motion.div
                    className="absolute w-24 h-24 rounded-full border-4"
                    style={{
                        borderColor: theme.light,
                        borderTopColor: theme.yellow,
                        boxShadow: `0 0 25px ${theme.light}`,
                    }}
                    animate={{ rotate: -360 }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "linear",
                    }}
                />

                {/* Reward Coin */}
                <motion.div
                    className="w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold"
                    style={{
                        background: `linear-gradient(135deg, ${theme.yellow}, #ffd700)`,
                        color: theme.deep,
                        boxShadow: `
              0 0 15px ${theme.yellow},
              0 0 35px ${theme.yellow}
            `,
                    }}
                    animate={{
                        scale: [1, 1.12, 1],
                        y: [0, -6, 0],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                    }}
                >
                    🏆
                </motion.div>

                {/* Floating Particles */}
                {[...Array(8)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-2 h-2 rounded-full"
                        style={{
                            background: theme.yellow,
                        }}
                        animate={{
                            rotate: 360,
                        }}
                        transition={{
                            duration: 4,
                            repeat: Infinity,
                            ease: "linear",
                            delay: i * 0.2,
                        }}
                    >
                        <div
                            style={{
                                transform: `translateY(-55px)`,
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                background: theme.yellow,
                                boxShadow: `0 0 10px ${theme.yellow}`,
                            }}
                        />
                    </motion.div>
                ))}
            </div>
        </div>
    );
}